var fileUploaded = false;

"use strict";
var PS = PS || {};
var setId='';
var widget_1;var widget_2;var widget_3;
if( typeof PS.RECAPTCHA === 'undefined' && typeof recaptcha_site_key != 'undefined' ) {
    (function (a, $) {
        var retryTime = 300;
        var x = {
            init: function(){
                if(typeof grecaptcha != 'undefined'){
                    //For Form 1 Initialization
                    if($('#stickformgoogle #recaptcha-form-1').length > 0){
                        var callbackFn = {
                            action : function(){
                                saveData('stickformgoogle'); //Here Callback Function
                            }
                        }
                        /*--- 'recaptcha-form-1' - reCaptcha div ID | 'form1' - Form ID ---*/
                        widget_1 = x.renderInvisibleReCaptcha('recaptcha-form-1',x.createCallbackFn(widget_1,'form1',callbackFn));

                    }

                    //For Form 2 Initialization
                    if($('#bannerformgoogle #recaptcha-form-2').length > 0){
                        var callbackFn = {
                            action : function(){
                                saveData('bannerformgoogle'); //Here Callback Function
                            }
                        }
                        /*--- 'recaptcha-form-2' - reCaptcha div ID | 'form2' - Form ID ---*/
                        widget_2 = x.renderInvisibleReCaptcha('recaptcha-form-2',x.createCallbackFn(widget_2,'form2',callbackFn));
                    }

                }else{
                    setTimeout(function(){ x.init();} , retryTime);
                }
            },
            renderInvisibleReCaptcha: function(recaptchaID,callbackFunction){
                    return grecaptcha.render(recaptchaID, {
                            'sitekey'   : recaptcha_site_key,
                            "theme"     : "light",
                            'size'      : 'invisible',
                            'badge'     : 'inline',
                            'callback'  : callbackFunction
                        });
            },
            createCallbackFn: function (widget,formID,callbackFn) {
                return function(token) {
                   let captchatElement=$('#'+formID+' .g-recaptcha-response');
                    if(captchatElement!=null){
                    captchatElement.val(token);
                    if($.trim(token) == ''){
                        grecaptcha.reset(widget);
                    }else{
                        callbackFn.action();
                    }
                    }
                }
            }
        }
        a.RECAPTCHA = x;
    })( PS, $ );
}


//function CaptchaCallback(){
    //  if(typeof recaptcha_site_key != 'undefined' ) {
    //     PS.RECAPTCHA.init();
    // }
//}

function renderReCaptcha(){
    if(typeof recaptcha_site_key != 'undefined' ) {
        PS.RECAPTCHA.init();
    }
}
$(document).ready(function(){
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.google.com/recaptcha/api.js?onload=renderReCaptcha&render=explicit';
    head.appendChild(script);
});

// function bannerFormSubmittion(){
//     if(formvalidationnew1('email','autocomplete','page','date','time','description','Due_Date')){
//         document.getElementById('indexForm').disabled=true;
//         $("#indexForm img").removeClass('hide');
//         return true;
//     }else{return false;}
// }


function addFilebox(action){
    if(action==1){
        document.getElementById('skipFileAdding').value=1;
        $('#indexForm').click();
    }else{
        $('input[type=file]').click();
        $('.file-select').css('pointer-events','auto');
    }
    $('.val_prompt').addClass('d-none')
}

// function formvalidationnew1(email, subject, page, date, time, description, dueDate) {
// $(".ans-error").addClass('hide');
// $(".ans-error").html("");

// var emaildata = document.getElementById(email).value;
// $("#"+email).closest(".form-group").removeClass("error");
// var subjectdata = document.getElementById(subject).value;
// $("#"+subject).closest(".form-group").removeClass("error");
// var pagedata = document.getElementById(page).value;

// var datedata = document.getElementById(date).value;
// var dateArray = datedata.split(" ");
// // console.log(dateArray);return false;
// datedata = dateArray[0];
// document.getElementById(dueDate).value = datedata;
// $("#"+date).closest(".form-group").removeClass("error");
// var descriptiondata = document.getElementById(description).value;
// $("#"+description).closest(".form-group").removeClass("error");
// var d = new Date();
// var validate = 1;
// if (time != "") {
//     //var timedata = document.getElementById(time).value;
//     var timedata = dateArray[1] + " " + dateArray[2];
//     document.getElementById(time).value = timedata;
//     //document.getElementById(time).classList.remove("error");
//     var validate = 1;
//     var d = new Date();
//     var month = d.getMonth() + 1;
//     var day = d.getDate();
//     var cuudate =
//         (day < 10 ? "0" : "") +
//         day +
//         "-" +
//         (month < 10 ? "0" : "") +
//         month +
//         "-" +
//         d.getFullYear();

//     //console.log(cuudate,datedata);

//     if (cuudate == datedata) {
//         var currtime = d.getHours();
//         var firsttime = timedata.split(":");

//         //console.log(timedata,currtime,firsttime);

//         if (
//             (firsttime[0] != "12" && firsttime[1] == "00 PM") ||
//             firsttime[1] == "59 PM"
//         ) {
//             var valdtimedata = parseInt(firsttime[0]) + 12;
//         } else {
//             var valdtimedata = parseInt(firsttime[0]);
//         }
//     }
// } else {
//     var currtime = d.getHours();
//     if (currtime < 12) {
//         document.getElementById("Select_Deadline").value = "12:00 PM";
//     } else {
//         document.getElementById("Select_Deadline").value = "11:59 PM";
//     }
// }

// var fileclass = ".file-con";

// var reEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

// if (emaildata.trim() == "") {
//     $("#"+email).closest(".form-group").addClass("error");
//     document.getElementById(email).focus();
//     validate = 0;
// } else if (!emaildata.match(reEmail) || emaildata.length>100) {
//     $("#"+email).closest(".form-group").addClass("error");
//     document.getElementById(email).focus();
//     validate = 0;
// } else if (subjectdata.trim() == "") {
//     $("#"+subject).closest(".form-group").addClass("error");
//     document.getElementById(subject).focus();
//     validate = 0;
// }
// else if (datedata.trim() == "") {
//     $("#"+date).closest(".form-group").addClass("error");
//     //document.getElementById(date).focus();
//     validate = 0;
// }
// // else if (pagedata.trim() == "") {
// //     document.getElementById(page).classList.add("form-error");
// //     document.getElementById(page).focus();
// //     validate = 0;
// // }
// else if (descriptiondata.trim() == "" && $(fileclass).length<1) {
//     $("#"+description).closest(".form-group").addClass("error");
//     document.getElementById(description).focus();
//     validate = 0;
// }
// if (time != "") {
//     if (timedata.trim() == "") {
//         // document.getElementById(time).classList.add("form-error");
//         // document.getElementById(time).focus();
//         validate = 0;
//     } else if (valdtimedata <= currtime) {
//         // document.getElementById(time).classList.add("form-error");
//         // document.getElementById(time).focus();
//         validate = 0;
//     }
// }
// if (validate == 0) {
//     return false
// }
// else{
//     if(!($("div#demo-files2 div.file-con").length>0 || parseInt($('#skipFileAdding').val())>0)) {
//             $('.val_prompt').removeClass('d-none');
//             validate = 0;
//     }else {
//         if (document.getElementById('overlay') != null) {
//             document.getElementById('overlay').style.display = 'block';
//         }
//     }
// }

// if (validate == 0) {
//     return false;
// } else {
//     if (email == "topemail") {
//          setId = "headerForm";
//     } else if (email == "email") {
//          setId = "indexForm";
//     } else {
//          setId = "otherForm";
//     }
//     if(typeof recaptcha_site_key != 'undefined' ){
//         switch(setId){
//             case 'headerForm' : grecaptcha.execute(widget_1); break;
//             case 'indexForm' : grecaptcha.execute(widget_2); break;
//             case 'otherForm' : grecaptcha.execute(widget_2); break;
//             }
//           return false;
//     }
//     else{
//         $("#" + setId)
//         .find("img")
//         .removeClass("hide");
//         $('form').css('pointer-events', 'none');
//         //$('.stepOne').attr('disabled', true);
//         return true;
//     }

// }
// }

$(document).on('keyup','.Email',function(){
    $('.Email').val($(this).val());
    var email = $(this).attr("id");
    var emaildata = document.getElementById(email).value;
    $("#"+email).parent('div').removeClass("error");
    var reEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (emaildata.trim() == "") {
        $("#"+email).parent('div').addClass("error");
        document.getElementById(email).focus();
    } else if (!emaildata.match(reEmail) || emaildata.length>100) {
        $("#"+email).parent('div').addClass('error');
        document.getElementById(email).focus();
    }else{
        if(emaildata.match(reEmail)){
            $("#"+email).parent('div').removeClass('error');
        }
        
    }
    opendedtalsection();
});

$(document).on('keyup','.Subject',function(){
    $('.Subject').val($(this).val());
    var subject = $(this).attr("id");
    var subjectdata = document.getElementById(subject).value;
    $("#"+subject).parent('div').parent('div').removeClass("error");;
    if (subjectdata.trim() == "") {
        $("#"+subject).parent('div').parent('div').addClass("error");
        document.getElementById(subject).focus();
    }
    opendedtalsection();
});

$(document).on('change','.Subject',function(){
    $('.Subject').val($(this).val());
    var subject = $(this).attr("id");
    var subjectdata = document.getElementById(subject).value;
    $("#"+subject).parent('div').parent('div').removeClass("error");
    if (subjectdata.trim() == "") {
        $("#"+subject).parent('div').parent('div').addClass("error");
        document.getElementById(subject).focus();
    }
    //opendedtalsection();
});

$(document).on('click keyup change','#datetimepicker7',function(){
    // $('#date').val($(this).val());
    // var date = $(this).attr("id");
    var datedata = document.getElementById('date').value;
    var dateArray = datedata.split(" ");
    datedata = dateArray[0];
    $("#date").parent('div').parent('div').parent('div').parent('div').removeClass("error");
    if (datedata.trim() == "") {
        $("#date").parent('div').parent('div').parent('div').parent('div').addClass("error");
        //document.getElementById(date).focus();
    }
    opendedtalsection();
});

$(document).on("change", "#onlineexmfiles", function(){
     var output = [];
      var totalfiles = document.getElementById('onlineexmfiles').files.length;
      var html = "";
      for (var index = 0; index < totalfiles; index++) {
        fileIdCounter++;
        var file = document.getElementById('onlineexmfiles').files[index];
        var fileId = sectionIdentifier + fileIdCounter;
    
        filesToUpload.push({
            id: fileId,
            file: file
        });
    
        output.push('<div class="col-6 col-md-4 mb-2"><p class="filename float-left m-0">'+file.name+'</p><button class="del remove-file" data-fileid="'+fileId+'"><img src="https://cdn1.myassignmenthelp.com/lazyload-assets/online-exam/trash-can-outline.svg"></button></div>');
    
        //html += '<div class="col-6 col-md-4 mb-2"><p class="filename float-left m-0">'+document.getElementById('files').files[index].name+'</p><button class="del remove-file" data-fileid="'+fileId+'"><img src="https://pradeep-pant.nerdy.citeall.com/trash-can-outline.svg"></button></div>';
      }
      $("#all-files-exam").append(output.join(""));
      document.getElementById('onlineexmfiles').value = null;
    });

$('#datetimepicker5, #datetimepickerNew').on('dp.change', function(e){
    //console.log(e.date);
    var val = $(this).find("input").val();
    $('.Due_Date').val(val);
    var date = $(this).find("input").attr("id");
    var datedata = document.getElementById(date).value;
    var dateArray = datedata.split(" ");
    datedata = dateArray[0];
    $("#"+date).closest(".form-group").removeClass("error");
    if (datedata.trim() == "") {
        $("#"+date).closest(".form-group").addClass("error");
        //document.getElementById(date).focus();
    }
    opendedtalsection();
});

$(document).on('keyup','.Detail',function(){
    $('.Detail').val($(this).val());
    var fileclass = ".file-con";
    var description = $(this).attr("id");
    var descriptiondata = document.getElementById(description).value;
    $("#"+description).closest(".form-group").removeClass("error");
    if (descriptiondata.trim() == "" && $(fileclass).length<1) {
        $("#"+description).closest(".form-group").addClass("error");
        document.getElementById(description).focus();
    }
    opendedtalsection();
});


function decpagecountNew(page, wordcnt, wordtxt, dtype, type){
    if(type == "header"){
        decpagecount(page, wordcnt, wordtxt, dtype);
        if($("#page").length){
            decpagecount('page','word_limit','wordtxt','numberonly');// country pages
        }
        else if($("#page123").length){
            decpagecount('sidebarpages','word_limit','page123','numbertxt');// sidebar for sample, answers, reviews
        }
    }
    else if(type == "banner"){
        decpagecount(page, wordcnt, wordtxt, dtype);
        decpagecount('toppagecnt','topword_limit','toppages','numbertxt');// header
    }
}

function incpagecountNew(page, wordcnt, wordtxt, dtype, type){
    if(type == "header"){
        incpagecount(page, wordcnt, wordtxt, dtype);
        if($("#page").length){
            incpagecount('page','word_limit','wordtxt','numberonly');// country pages
        }
        else if($("#page123").length){
            incpagecount('sidebarpages','word_limit','page123','numbertxt');// sidebar for sample, answers, reviews
        }
    }
    else if(type == "banner"){
        incpagecount(page, wordcnt, wordtxt, dtype);
        // incpagecount('toppagecnt','topword_limit','toppages','numbertxt');// header
    }
}

function incpagecount(page, wordcnt, wordtxt, dtype) {
    var pagedata = document.getElementById(page).value;
    if (dtype == "numberonly") {
        if (pagedata < 0) {
            document.getElementById(page).value = 1;
            document.getElementById(wordcnt).value = 250;
            document.getElementById(wordtxt).innerHTML = "250 words";
        } else {
            var claval = parseInt(pagedata) + 1;
            document.getElementById(page).value = claval;
            document.getElementById(wordcnt).value = parseInt(claval * 250);
            document.getElementById(wordtxt).innerHTML =
                parseInt(claval * 250) + " words";
        }
    }
    if (dtype == "numbertxt") {
        if (pagedata < 0) {
            document.getElementById(page).value = 1;
            document.getElementById(wordcnt).value = 250;
            document.getElementById(wordtxt).value = "1 Page/250 Words";
        } else {
            var claval = parseInt(pagedata) + 1;
            document.getElementById(page).value = claval;
            document.getElementById(wordcnt).value = parseInt(claval * 250);
            document.getElementById(wordtxt).value =
                claval + " Pages/" + parseInt(claval * 250) + " Words";
        }
    }
    return false;
}

function decpagecount(page, wordcnt, wordtxt, dtype) {
    var pagedata = document.getElementById(page).value;
    if (dtype == "numberonly") {
        if (pagedata <= 1) {
            document.getElementById(page).value = 1;
            document.getElementById(wordcnt).value = 250;
            document.getElementById(wordtxt).innerHTML = "250 words";
        } else {
            var claval = parseInt(pagedata) - 1;
            document.getElementById(page).value = claval;
            document.getElementById(wordcnt).value = parseInt(claval * 250);
            document.getElementById(wordtxt).innerHTML =
                parseInt(claval * 250) + " words";
        }
    }
    if (dtype == "numbertxt") {
        if (pagedata <= 1) {
            document.getElementById(page).value = 1;
            document.getElementById(wordcnt).value = 250;
            document.getElementById(wordtxt).value = "1 Page/250 Words";
        } else {
            var claval = parseInt(pagedata) - 1;
            document.getElementById(page).value = claval;
            document.getElementById(wordcnt).value = parseInt(claval * 250);
            if (claval == 1) {
                document.getElementById(wordtxt).value = "1 Page/250 Words";
            } else {
                document.getElementById(wordtxt).value =
                    claval + " Pages/" + parseInt(claval * 250) + " Words";
            }
        }
    }
    return false;
}

/** dm uploader for files upload based on ajax **/
require('../../../node_modules/dm-file-uploader/dist/js/jquery.dm-uploader.min.js');
$(document).ready(function () {
    var $DMContainer = $(".desc-drag");
    var $fileContainer = $(".demo-files2");
    var $fileUploaderContainer = $(".file-uploader-container");
    var $fileLoaderIndicator = $(".file-uploader-progress-bar");
    var $page_url = $("#page_url").val();
    $fileUploaderContainer.hide();

    $DMContainer.dmUploader({
        multiple: true,
        extFilter:['png','gif','jpg','jpeg','tif','pdf','psd','doc','docx','xls','xlsx','ppt','pptx','rtf','txt','mpp','zip','rar','odt','csv'],
        //extFilter: ['pdf','doc','docx','pptx','txt','xlsx','csv'],
        url: $page_url + '/Home/file-upload',
        //+pathName.split('/')[1]+"/files-upload.php?Type=orders",
        ///mah-live/Home/file-upload
        dataType: 'json',
        extraData: { "type":'orders','_token':$('input[name=csrf_token]').val() },
        onNewFile: function (id, file) {
            $('.stepOne').attr('disabled', true);
            $(".file-select").css('pointer-events','none');
            $(".ans-error").addClass('hide');
            $(".ans-error").html('');
        },
        onComplete: function () {
            $('.progress').addClass('hide');
            $('.stepOne').attr('disabled', false);
            $(".delete-btn").attr('disabled', false);
        },
        onUploadProgress: function (id, percent) {
            fileUploaded=false;
            var percentStr = percent + '% Complete';
            $('.progress').removeClass('hide');
            $('.uploaderProgressBar').attr('aria-valuenow', percent).css('width', percent + "%");
            $(".file-select").css('pointer-events','none');
        },
        onFileTypeError: function (file) {
            fileUploaded=false;
            $('#fileupload').val('');
            $(".ans-error").removeClass('hide');
            $(".ans-error").html(file.name + ' cannot be added: file type is wrong');
            error_message_hide('.ans-error');

        },
        onFileSizeError: function (file) {
            fileUploaded=false;
            $('#fileupload').val('');
            $(".ans-error").removeClass('hide');
            $(".ans-error").html(file.name + ' cannot be added: size excess limit');
            error_message_hide('.ans-error');
        },
        onFileExtError: function (file) {
            fileUploaded=false;
            $('#fileupload').val('');
            $(".ans-error").removeClass('hide');
            $(".ans-error").html(file.name + ' cannot be added: file extension is wrong');
            error_message_hide('.ans-error');
        },
        onUploadSuccess:function(id,data){
            fileUploaded=true;
            $(".file-select").css('pointer-events','auto');
            $(".ans-error").addClass('hide');
            $(".ans-error").html('');
            if(typeof data.error != "undefined" && data.error != null){
                $(".ans-error").removeClass('hide');
                $(".ans-error").html(data.error);
                error_message_hide('.ans-error');
            }else{
                add_file('.demo-files2', id, data.fileName, 'orders');
                $('#fileupload').val(data.fileName);
                $(".Detail").closest(".form-group").removeClass("error");
            }
        }
    });

});

function add_file(showid, e, d, type) {
    if ((d.replace(/[^a-zA-Z0-9.-]+/g, "")).length > 20) {
        var filename = (d.replace(/[^a-zA-Z0-9.-]+/g, "")).substring(0, 17) + '...';
    }
    else {
        var filename = d.replace(/[^a-zA-Z0-9.-]+/g, "");
    }
    var f = '<div id="demo-file' + e + '" class="mt-2 file-con demo-file' + e + '"><p class="filename float-left m-0">'+filename+'</p><button type="button" disabled="disabled" class="transparent delete-btn" data-fileid="files1" onclick="delfile(\'' + type + '\',\'' + d + '\');deleteParent(\'' + e + '\');" title="Remove"><img src="https://cdn1.myassignmenthelp.store/lazyload-assets/country-v2/trash-can-outline.svg"></button></div>';
    $(showid).prepend(f);
}

function deleteParent(el){
    // $(el).parent().remove();
    $(".demo-file"+el).remove();

}

function error_message_hide(id) {
    setTimeout(function(){
        $(id).addClass('hide');
    },8000);
    //$(id).css("display", "block");
}

function delfile(Type, File) {
    $('.stepOne').attr('disabled', true);
    let baseUrl=document.getElementById('base_url').getAttribute('content');
    $.post(baseUrl+"/Home/file-delete", {
        type: Type,
        fileName: File,
        _token:$('input[name=csrf_token]').val()
    },
    function (data) {
        fileUploaded=false;
        $('#fileupload').val('');
        $('.stepOne').attr('disabled', false);
        var fileclass = ".file-con";
        var descriptiondata = $(".Detail").val();
        $(".Detail").closest(".form-group").removeClass("error");
        if (descriptiondata.trim() == "" && $(fileclass).length<1) {
            $(".Detail").closest(".form-group").addClass("error");
        }
    });
}

function opendedtalsection(){
    if($('.Email').val().trim()!='' && $('.Subject').val().trim()!='' && $('.Due_Date').val().trim()!=''){
     $('.DetailHide').removeClass('hide');
     $('.Detail').removeClass('form-error');
    }else{
     $('.DetailHide').addClass('hide');
    }
}

function saveData(form){
 $("#" + setId).find("img").removeClass("hide");
 $('form').css('pointer-events', 'none');
 $('.stepOne').attr('disabled', true);
 document.getElementById(form).submit();
}

// function bannerFormSubmittion2(){

//     $("#indexForm img").removeClass('hide');
//     if(formvalidationnew2('email','autocomplete','page','date','time','description','Due_Date')){
//         document.getElementById('indexForm').disabled=true;
//         return true;
//     }else{$("#indexForm img").addClass('hide');return false;}
// }

// function formvalidationnew2(email, subject, page, date, time, description, dueDate) {
//     $(".ans-error").addClass('hide');
//     $(".ans-error").html("");

//     var emaildata = document.getElementById(email).value;
//     $("#"+email).closest(".__input-box").removeClass("error");
//     var subjectdata = document.getElementById(subject).value;
//     $("#"+subject).closest(".__input-box").removeClass("error");
//     var pagedata = document.getElementById(page).value;

//     var datedata = document.getElementById(date).value;
//     var dateArray = datedata.split(" ");
//     // console.log(dateArray);return false;
//     datedata = dateArray[0];
//     document.getElementById(dueDate).value = datedata;
//     $("#"+date).closest(".__input-box").removeClass("error");
//     var descriptiondata = document.getElementById(description).value;
//     $("#"+description).closest(".__input-box").removeClass("error");
//     var d = new Date();
//     var validate = 1;
//     if (time != "") {
//         //var timedata = document.getElementById(time).value;
//         var timedata = dateArray[1] + " " + dateArray[2];
//         document.getElementById(time).value = timedata;
//         //document.getElementById(time).classList.remove("error");
//         var validate = 1;
//         var d = new Date();
//         var month = d.getMonth() + 1;
//         var day = d.getDate();
//         var cuudate =
//             (day < 10 ? "0" : "") +
//             day +
//             "-" +
//             (month < 10 ? "0" : "") +
//             month +
//             "-" +
//             d.getFullYear();

//         //console.log(cuudate,datedata);

//         if (cuudate == datedata) {
//             var currtime = d.getHours();
//             var firsttime = timedata.split(":");

//             //console.log(timedata,currtime,firsttime);

//             if (
//                 (firsttime[0] != "12" && firsttime[1] == "00 PM") ||
//                 firsttime[1] == "59 PM"
//             ) {
//                 var valdtimedata = parseInt(firsttime[0]) + 12;
//             } else {
//                 var valdtimedata = parseInt(firsttime[0]);
//             }
//         }
//     } else {
//         var currtime = d.getHours();
//         if (currtime < 12) {
//             document.getElementById("Select_Deadline").value = "12:00 PM";
//         } else {
//             document.getElementById("Select_Deadline").value = "11:59 PM";
//         }
//     }

//     //var reEmail = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;

//     // if (email == "topemail") {
//     //     var fileclass = ".file-con1";
//     // } else if (email == "email") {
//     //     var fileclass = ".file-con";
//     // } else {

//     // }

//     var fileclass = ".file-con";

//     var reEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

//     if (emaildata.trim() == "") {
//         $("#"+email).closest(".__input-box").addClass("error");
//         document.getElementById(email).focus();
//         validate = 0;
//     } else if (!emaildata.match(reEmail) || emaildata.length>100) {
//         $("#"+email).closest(".__input-box").addClass("error");
//         document.getElementById(email).focus();
//         validate = 0;
//     } else if (subjectdata.trim() == "") {
//         $("#"+subject).closest(".__input-box").addClass("error");
//         document.getElementById(subject).focus();
//         validate = 0;
//     }
//     else if (datedata.trim() == "") {
//         $("#"+date).closest(".__input-box").addClass("error");
//         //document.getElementById(date).focus();
//         validate = 0;
//     }
//         // else if (pagedata.trim() == "") {
//         //     document.getElementById(page).classList.add("form-error");
//         //     document.getElementById(page).focus();
//         //     validate = 0;
//     // }
//     else if (descriptiondata.trim() == "" && $(fileclass).length<1) {
//         $("#"+description).closest(".__input-box").addClass("error");
//         document.getElementById(description).focus();
//         validate = 0;
//     }
//     if (time != "") {
//         if (timedata.trim() == "") {
//             // document.getElementById(time).classList.add("form-error");
//             // document.getElementById(time).focus();
//             validate = 0;
//         } else if (valdtimedata <= currtime) {
//             // document.getElementById(time).classList.add("form-error");
//             // document.getElementById(time).focus();
//             validate = 0;
//         }
//     }
//     if (validate == 0) {
//         return false;
//     } else {

//         if(!($("div#demo-files2 div.file-con").length>0 || parseInt($('#skipFileAdding').val())>0)) {
//             $('.val_prompt').removeClass('d-none');
//             return false;
//         }else {
//             if (document.getElementById('overlay') != null) {
//                 document.getElementById('overlay').style.display = 'block';
//             }
//         }

//         if (email == "topemail") {
//             setId = "headerForm";
//         } else if (email == "email") {
//             setId = "indexForm";
//         } else {
//             setId = "otherForm";
//         }
//         if(typeof recaptcha_site_key != 'undefined' ){
//             switch(setId){
//                 case 'headerForm' : grecaptcha.execute(widget_1); break;
//                 case 'indexForm' : grecaptcha.execute(widget_2); break;
//                 case 'otherForm' : grecaptcha.execute(widget_2); break;
//             }
//             return false;
//         }
//         else{
//             $("#" + setId)
//                 .find("img")
//                 .removeClass("hide");
//             $('form').css('pointer-events', 'none');
//             //$('.stepOne').attr('disabled', true);
//             return true;
//         }

//     }
// }
var filesToUpload = [];
var fileIdCounter = 0;
var sectionIdentifier = "files";
function onlineformvalidation(email, subject, date, noofquestion, typeofquestion) {

    $("#error-label").html("");
  
    var emaildata = document.getElementById(email).value;
    $("#"+email).closest(".form-group").removeClass("error");
    var subjectdata = document.getElementById(subject).value;
    $("#"+subject).closest(".form-group").removeClass("error");
    var datedata = document.getElementById(date).value;
    $("#"+date).closest(".form-group").removeClass("error");
    var noofquestiondata = document.getElementById(noofquestion).value;
    $("#"+noofquestion).closest(".form-group").removeClass("error");
    var typeofquestiondata = document.getElementById(typeofquestion).value;
    $("#"+typeofquestion).closest(".form-group").removeClass("error");
  
    var d = new Date();
    var validate = 1;
    // if (time != "") {
    //     var timedata = document.getElementById(time).value;
    //     $("#"+time).closest(".form-group").removeClass("error");
    //     var validate = 1;
    //     var d = new Date();
    //     var month = d.getMonth() + 1;
    //     var day = d.getDate();
    //     var cuudate =
    //         (day < 10 ? "0" : "") +
    //         day +
    //         "-" +
    //         (month < 10 ? "0" : "") +
    //         month +
    //         "-" +
    //         d.getFullYear();
  
    //     //console.log(cuudate,datedata);
  
    //     if (cuudate == datedata) {
    //         var currtime = d.getHours();
    //         var firsttime = timedata.split(":");
  
    //         //console.log(timedata,currtime,firsttime);
  
    //         if (
    //             (firsttime[0] != "12" && firsttime[1] == "00 PM") ||
    //             firsttime[1] == "59 PM"
    //         ) {
    //             var valdtimedata = parseInt(firsttime[0]) + 12;
    //         } else {
    //             var valdtimedata = parseInt(firsttime[0]);
    //         }
    //     }
    // } else {
    //     var currtime = d.getHours();
    //     if (currtime < 12) {
    //         document.getElementById("Select_Deadline").value = "12:00 PM";
    //     } else {
    //         document.getElementById("Select_Deadline").value = "11:59 PM";
    //     }
    // }
  
    //var reEmail = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
  
    var reEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  
    if (emaildata.trim() == "") {
        $("#"+email).closest(".form-group").addClass("error");

        document.getElementById(email).focus();
        validate = 0;
    } else if (!emaildata.match(reEmail)) {
        $("#"+email).closest(".form-group").addClass("error");
        document.getElementById(email).focus();
        validate = 0;
    } else if (subjectdata.trim() == "") {
        $("#"+subject).closest(".form-group").addClass("error");
        document.getElementById(subject).focus();
        validate = 0;
    } else if (datedata.trim() == "") {
        $("#"+date).closest(".form-group").addClass("error");
        document.getElementById(date).focus();
        validate = 0;
    }
    
    // else if (timedata.trim() == "") {
    //     $("#"+time).closest(".form-group").addClass("error");
    //     document.getElementById(time).focus();
    //     validate = 0;
    // } else if (valdtimedata <= currtime) {
    //     $("#"+time).closest(".form-group").addClass("error");
    //     document.getElementById(time).focus();
    //     validate = 0;
    // }
    
    else if (noofquestiondata.trim() == "") {
      $("#"+noofquestion).closest(".form-group").addClass("error");
      document.getElementById(noofquestion).focus();
      validate = 0;
    }
    else if (typeofquestiondata.trim() == "") {
      $("#"+typeofquestion).closest(".form-group").addClass("error");
      document.getElementById(typeofquestion).focus();
      validate = 0;
    }
    
    if (validate == 0) {
        return false;
    } else {
        var setId = "indexForm";
        $("#" + setId).find("img").removeClass("d-none");
        $("#" + setId).addClass("disabled");
        document.getElementById("bannerformgoogle").style.pointerEvents = "none";
        //return true;
  
        // form.js
  
        const formId = "bannerformgoogle"; // ID of the form
        const url = location.href; //  href for the page
        const formIdentifier = `${url} ${formId}`; // Identifier used to identify the form
        
        let form = document.querySelector(`#${formId}`); // select form
        let formElements = form.elements; // get the elements in the form
        let data;
        const getFormData = () => {
          data = { [formIdentifier]: {} }; // create an empty object with the formIdentifier as the key and an empty object as its value
          for (const element of formElements) {
            if (element.name.length > 0) {
              data[formIdentifier][element.name] = element.value;
            }
          }
          return data;
        };
  
        data = getFormData();
        localStorage.setItem(formIdentifier, JSON.stringify(data[formIdentifier]));
  
        setTimeout(function(){
          if (localStorage.key(formIdentifier)) {
  
            $("#bannerformgoogle").hide();
            $("#online-second-form").show();
          }
          else{
            localStorage.removeItem(formIdentifier);
            $("#bannerformgoogle")[0].reset();
            $("#online-second-form")[0].reset();
            $("#bannerformgoogle").show();
            $("#online-second-form").hide();
          }
          $("#" + setId).find("img").addClass("d-none");
          $("#" + setId).removeClass("disabled");
          document.getElementById("bannerformgoogle").style.pointerEvents = "auto";
        },3000);
        
        
  
        return false;
  
    }
  }

  function onlineformvalidation2(durationofquestion, noofattempt, url, username, password, countryCode, mobileNumber) {

  $("#error-label").html("");

  var durationofquestiondata = document.getElementById(durationofquestion).value;
  $("#"+durationofquestion).closest(".form-group").removeClass("error");
  var noofattemptdata = document.getElementById(noofattempt).value;
  $("#"+noofattempt).closest(".form-group").removeClass("error");
  var urldata = document.getElementById(url).value;
  $("#"+url).closest(".form-group").removeClass("error");
  var usernamedata = document.getElementById(username).value;
  $("#"+username).closest(".form-group").removeClass("error");
  var passworddata = document.getElementById(password).value;
  $("#"+password).closest(".form-group").removeClass("error");
  var mobileNumberdata = document.getElementById(mobileNumber).value;
  $("#"+mobileNumber).closest(".form-group").removeClass("error");
  var countryCodedata = document.getElementById(countryCode).value;
  $("#"+countryCode).closest(".form-group").removeClass("error");

  /**
   * check box
   */
  var chk = 0;
  if($("#is_sendy").is(":checked")){
      chk = $("#is_sendy").val();
  }

  var validate = 1;

  //var reEmail = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;

  var reEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  var reUrl = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  var reMob = /^\d+$/;

  if (durationofquestiondata.trim() == "") {
      $("#"+durationofquestion).closest(".form-group").addClass("error");
      document.getElementById(durationofquestion).focus();
      validate = 0;
  } else if (noofattemptdata.trim() == "") {
      $("#"+noofattempt).closest(".form-group").addClass("error");
      document.getElementById(noofattempt).focus();
      validate = 0;
  } else if (urldata.trim() == "") {
      $("#"+url).closest(".form-group").addClass("error");
      document.getElementById(url).focus();
      validate = 0;
  }
  else if (!urldata.match(reUrl)) {
    $("#"+url).closest(".form-group").addClass("error");
    document.getElementById(url).focus();
    validate = 0;
}
  else if (usernamedata.trim() == "") {
    $("#"+username).closest(".form-group").addClass("error");
    document.getElementById(username).focus();
    validate = 0;
  }
  else if (passworddata.trim() == "") {
    $("#"+password).closest(".form-group").addClass("error");
    document.getElementById(password).focus();
    validate = 0;
  }
  else if (countryCodedata.trim() == "") {
    $("#"+countryCode).closest(".form-group").addClass("error");
    document.getElementById(countryCode).focus();
    validate = 0;
  }
  else if (mobileNumberdata.trim() == "") {
    $("#"+mobileNumber).closest(".form-group").addClass("error");
    document.getElementById(mobileNumber).focus();
    validate = 0;
  }
  else if (!mobileNumberdata.match(reMob)) {
    $("#"+mobileNumber).closest(".form-group").addClass("error");
    document.getElementById(mobileNumber).focus();
    validate = 0;
  }
  else if (mobileNumberdata.length < 6 || mobileNumberdata.length > 16) {
    $("#"+mobileNumber).closest(".form-group").addClass("error");
    document.getElementById(mobileNumber).focus();
    validate = 0;
  }
  
  
  if (validate == 0) {
      return false;
  } else {
      var setId = "indexForm2";
      $("#" + setId).find("img").removeClass("d-none");
      $("#" + setId).addClass("disabled");
      document.getElementById("online-second-form").style.pointerEvents = "none";
      //return true;

      // form.js

      const formId = "online-second-form"; // ID of the form
      const url = location.href; //  href for the page
      const formIdentifier = `${url} ${formId}`; // Identifier used to identify the form
      
      let form = document.querySelector(`#${formId}`); // select form
      let formElements = form.elements; // get the elements in the form
      let data;
      const getFormData = () => {
        data = { [formIdentifier]: {} }; // create an empty object with the formIdentifier as the key and an empty object as its value
        for (const element of formElements) {
          if (element.name.length > 0) {
            data[formIdentifier][element.name] = element.value;
          }
        }
        return data;
      };

      data = getFormData();
      localStorage.setItem(formIdentifier, JSON.stringify(data[formIdentifier]));

      const formId1 = "online-first-form"; // ID of the form
      const formIdentifier1 = `${url} ${formId1}`; // Identifier used to identify the form

      
      if (localStorage.key(formIdentifier) && localStorage.key(formIdentifier1)) {

        // console.log(localStorage.getItem(formIdentifier));
        // console.log(localStorage.getItem(formIdentifier1));

        // console.log(JSON.stringify($.extend(false,{},localStorage.getItem(formIdentifier),localStorage.getItem(formIdentifier1))));

        var form_data = new FormData();     
        //var totalfiles = document.getElementById('files').files.length;
        var totalfiles = filesToUpload.length;
        for (var index = 0; index < totalfiles; index++) {
          //form_data.append("files[]", document.getElementById('files').files[index]);
          form_data.append("files[]", filesToUpload[index].file);
        }
        form_data.append('form1', localStorage.getItem(formIdentifier1));
        form_data.append('form2', localStorage.getItem(formIdentifier));
        form_data.append('action', 'submitexam');
        form_data.append('is_sendy', chk);
        $.ajax({
          url: DOMAIN_NAME + "/online-exam-process.php",
          type: "post",
          //data: "action='submitexam'&form1="+localStorage.getItem(formIdentifier1)+"&form2="+localStorage.getItem(formIdentifier),
          data: form_data,
          cache: false,
          contentType: false,
          processData: false,
          success: function(response){
            
            $("#" + setId).find("img").addClass("d-none");
            $("#" + setId).removeClass("disabled");
            document.getElementById("online-second-form").style.pointerEvents = "auto";
            
            if(response!=0){
              localStorage.removeItem(formIdentifier1);
              localStorage.removeItem(formIdentifier);
              $("#online-first-form")[0].reset();
              $("#online-second-form")[0].reset();
              $("#online-first-form").show();
              $("#online-second-form").hide();

              for (var i = 0; i < filesToUpload.length; ++i) {
                if (filesToUpload[i].id.indexOf(sectionIdentifier) >= 0)
                    filesToUpload.splice(i, 1);
              }

              filesToUpload = [];
              $("#all-files-exam").empty();
              //redirect
              window.location.href = response;
            }
            else{
              $("#error-label").html("Something Wrong!! Please try again.");
            }            
          }
        });
      }
      else{
        localStorage.removeItem(formIdentifier1);
        localStorage.removeItem(formIdentifier);
        $("#online-first-form")[0].reset();
        $("#online-second-form")[0].reset();
        $("#online-first-form").show();
        $("#online-second-form").hide();
        $("#" + setId).find("img").addClass("d-none");
        $("#" + setId).removeClass("disabled");
      }
      return false;

  }
}

window.addEventListener('DOMContentLoaded', (event) => {
    $('#datetimepicker7').datetimepicker({
        //  debug:true,
        keepOpen: true,
        ignoreReadonly: true,
        widgetPositioning: {
            vertical: "bottom"
        },
        icons: {
            time: "timeIcon",
            date: "calendarIcon",
            up: "topArrow",
            down: "bottomArrow",
            previous: "leftArrow",
            next: "rightArrow"
        },
        format: "MM/DD/YYYY h:mm A",
        minDate:new Date()
    });
});

window.decpagecount = decpagecount;
// window.bannerFormSubmittion= bannerFormSubmittion;
window.incpagecount = incpagecount;
window.decpagecountNew = decpagecountNew;
window.incpagecountNew = incpagecountNew;
// window.formvalidationnew1 = formvalidationnew1;
window.add_file = add_file;
window.delfile = delfile;
window.error_message_hide = error_message_hide;
window.deleteParent = deleteParent;
window.opendedtalsection=opendedtalsection;
window.saveData=saveData;
//window.CaptchaCallback = CaptchaCallback;
window.renderReCaptcha = renderReCaptcha;
window.addFilebox = addFilebox;
// window.bannerFormSubmittion2= bannerFormSubmittion2;
// window.formvalidationnew2 = formvalidationnew2;
window.onlineformvalidation = onlineformvalidation;
window.onlineformvalidation2 = onlineformvalidation2;
